module.exports = __webpack_public_path__ + "static/media/tn.fe17f7dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tn.png
// module id = 1920
// module chunks = 0